import FullscreenSpinner from "./fullscreen-spinner";

export default FullscreenSpinner;
